module.exports = __webpack_public_path__ + "assets/img/4ebad66aa5977d5ec02537d84561d998.png";